export class User {

    err_kata: number;
    err_hira: number;
    ok_kata: number;
    ok_hira: number;
    tests_kata: number;
    tests_hira: number;
    results_tutorial: boolean;
    canvas_tutorial: boolean;
    language: string;

    constructor() {
        this.err_kata = 0;
        this.err_hira = 0;
        this.ok_kata = 0;
        this.ok_hira = 0;
        this.tests_kata = 0;
        this.tests_hira = 0;
        this.results_tutorial = true;
        this.canvas_tutorial = true;
        this.language = '';
}
}